export enum FileStateEnum {
  FileUploaded = 1,
  FileProcessing = 2,
  FileSucessfullyProcessed = 3,
  DuplicateFileDetected = 4,
  FileUploadUnsucessful = 5,
  FileUnsucessfullyProcessed = 6,
  FileProcessedWithErrors = 7,
}
